import React, { useRef } from "react";
import "../../../../node_modules/filepond/dist/filepond.min.css";
import { FilePond } from "react-filepond";
import { DownloadIcon } from "../../icons/DownloadIcon";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";
import classnames from "classnames";
import { useSelector } from "react-redux";
import ArrowRepeat from "./svg/ArrowRepeat";
import styled from "styled-components";

const FileUpload = (props) => {
  const {
    label,
    popoverText,
    colorPink,
    className,
    onerror,
    children,
    showReplaceBtn,
    ...params
  } = props;

  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.filePond,
  }));
  const user = document.querySelector("#app-user")
  const ref = useRef(null);
  const handleError = (e) => {
    if (e?.main?.includes("invalid type")) {
      onerror(lang[0]);
    } else if (e?.main?.includes("File is too large")) {
      onerror(lang[1]);
    }
  };
  const handleFilePondClick = (event) => {
    if (
      window.location.pathname.includes("qr-code-generator") &&
      user === null
    ) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = `/login?targetBack=${window.location.pathname}`;
    }
  };
  const handleReplaceFiles = () => {
    ref.current.removeFiles();
    ref.current.browse();
  };

  return (
    <Row
      className={classnames("position-relative flex-nowrap", {
        "mb-3": !className,
        [className]: !!className,
      })}
    >
      <Col xs={12} md={popoverText === null ? 12 : 11}>
        <div onClick={handleFilePondClick}>
        <FilePond
          ref={ref}
          files={params.files}
          {...params}
          className={classnames("filePondWrapper", {
            ["pink_color"]: !!colorPink,
          })}
          labelIdle={`<div class="${["filePondLable"]}">
           ${DownloadIcon()} ${label}</div>`}
          onerror={handleError}
          styleButtonRemoveItemPosition="right"
        />
        {params.files?.length > 0 && showReplaceBtn && (
          <ReplaceBtn
            className="position-absolute top-50 translate-middle end-0 cursor-pointer rounded-circle bg-danger d-flex align-items-center justify-content-center bg-opacity-75 text-white"
            onClick={handleReplaceFiles}
          >
            <ArrowRepeat />
          </ReplaceBtn>
        )}
        {children}
        </div>
      </Col>
      {popoverText !== null && (
        <div className="position-absolute top-50 translate-middle-y end-0 w-auto me-3">
          <PopoverBtn text={popoverText} />
        </div>
      )}
    </Row>
  );
};

export default FileUpload;

const ReplaceBtn = styled.div`
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
  width: 26px;
  height: 26px;
  margin-right: 58px;
  &:hover {
    border-color: white;
  }
`;
